import Link from "next/link";

import Tooltip from "@components/Tooltip";
import { resizeImage } from "@lib/helpers";

const ProductListColorVariations = ({ product }) => {
  const { sku, configurable_options } = product;

  const colorVariations = configurable_options.find(
    (option) => option.attribute_code === "culoare_global"
  );

  if (!colorVariations) {
    return null;
  }

  return (
    <ul className="inline-flex gap-[4px]">
      {colorVariations?.values?.map((option) => {
        if (sku == option.sku) {
          return null;
        }

        const swatch = (
          <Link href={`/${option.url_key}/cpd/${option.sku}/`}>
            <a>
              <img
                src={resizeImage(option.image, "40x40")}
                alt={option.label}
                className="w-[40px] h-[40px]"
              />
            </a>
          </Link>
        );

        return (
          <li
            key={option.id}
            className="border border-[#C7C7C7] rounded p-[4px] w-[50px] h-[50px]"
          >
            {option.label ? (
              // The swatches sit in a scrolling row, which would clip an
              // absolutely positioned tooltip
              <Tooltip content={option.label} strategy="fixed">
                {() => swatch}
              </Tooltip>
            ) : (
              swatch
            )}
          </li>
        );
      })}
    </ul>
  );
};

export default ProductListColorVariations;
